module.exports = __webpack_public_path__ + "img/person.e1d17d8b.png";